import React from 'react';

interface ShinyTextProps {
    text: string;
    disabled?: boolean;
    speed?: number;
    className?: string;
}

const ShinyText: React.FC<ShinyTextProps> = ({ text, disabled = false, speed = 2.5, className = '' }) => {
    const animationDuration = `${speed}s`;

    return (
        <div
            className={`shiny-text-hover bg-clip-text inline-block ${className}`}
            style={{
                backgroundImage: 'linear-gradient(90deg, #1a1a1a 0%, #1a1a1a 30%, #00ffff 50%, #1a1a1a 70%, #1a1a1a 100%)',
                backgroundSize: '200% 100%',
                backgroundPosition: '100% 0',
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
                color: disabled ? 'inherit' : 'inherit',
                WebkitTextFillColor: disabled ? 'inherit' : 'inherit',
                ['--animation-duration' as any]: animationDuration,
            }}
            data-disabled={disabled ? 'true' : 'false'}
        >
            {text}
        </div>
    );
};

export default ShinyText;

